module.exports = __webpack_public_path__ + "static/media/alert.c5e7a4c0.svg";